"use strict";

require("core-js/modules/es6.object.keys.js");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  formInputChanged: true,
  formOpen: true,
  formSubmit: true,
  formCancel: true,
  formMoveToPage: true,
  generateUUID: true,
  logPageView: true,
  getPageViewId: true,
  elementInteraction: true,
  errorEvent: true,
  customEvent: true,
  setProductImpressionMeta: true,
  reducer: true,
  actions: true
};
exports.actions = void 0;
Object.defineProperty(exports, "customEvent", {
  enumerable: true,
  get: function get() {
    return _customEvent.default;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "elementInteraction", {
  enumerable: true,
  get: function get() {
    return _elementInteraction.default;
  }
});
Object.defineProperty(exports, "errorEvent", {
  enumerable: true,
  get: function get() {
    return _errorEvent.default;
  }
});
exports.formSubmit = exports.formOpen = exports.formMoveToPage = exports.formInputChanged = exports.formCancel = void 0;
Object.defineProperty(exports, "generateUUID", {
  enumerable: true,
  get: function get() {
    return _metaUtils.generateUUID;
  }
});
Object.defineProperty(exports, "getPageViewId", {
  enumerable: true,
  get: function get() {
    return _getPageViewId.default;
  }
});
Object.defineProperty(exports, "logPageView", {
  enumerable: true,
  get: function get() {
    return _logPageView.default;
  }
});
Object.defineProperty(exports, "reducer", {
  enumerable: true,
  get: function get() {
    return _reducer.default;
  }
});
Object.defineProperty(exports, "setProductImpressionMeta", {
  enumerable: true,
  get: function get() {
    return _productImpression.default;
  }
});

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _metaUtils = require("./meta-utils");

var _formInteractionEvent = _interopRequireDefault(require("./form-interaction-event"));

var _logPageView = _interopRequireDefault(require("./log-page-view"));

var _getPageViewId = _interopRequireDefault(require("./get-page-view-id"));

var _elementInteraction = _interopRequireDefault(require("./element-interaction"));

var _errorEvent = _interopRequireDefault(require("./error-event"));

var _customEvent = _interopRequireDefault(require("./custom-event"));

var _productImpression = _interopRequireDefault(require("./product-impression"));

var _reducer = _interopRequireDefault(require("./reducer"));

var actions = _interopRequireWildcard(require("./actions"));

exports.actions = actions;

var Components = _interopRequireWildcard(require("./components"));

Object.keys(Components).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === Components[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return Components[key];
    }
  });
});

/**
 * Connects to NWA's event center to log the page view event.
 *
 * @param {String} path The path of the route that needs to be logged as a page view.
 */

/**
 * Connects to NWA's event center to log the form input changed event.
 *
 * @param info The tracking info to be sent to the NWA api.
 *
 * @param info.formName The name of the form. Should be independent from actual page,
 * and drawn from the form element.
 * @param info.inputType The type of input, as specified by the HTML input element.
 * @param info.fieldName Human-readable(-ish) name of a field, i.e. yearly-income.
 * Should be drawn from the input's label element.
 * @param info.fieldValue = The value of the input. It is not required,
 * as the value may be sensitive.
 * DO NOT INCLUDE FOR NOW!
 *
 * @see https://nerdwallet.atlassian.net/wiki/display/ENG/Event+Schemas#EventSchemas-FormInputChangedEvent
 */
var formInputChanged = _formInteractionEvent.default.onInputChanged;
/**
 * A flavor of the form interaction event (named formInputChanged for legacy reasons)
 * but with action enum FORM_OPEN.
 *
 * Invoked when a modal dialog is opened.
 */

exports.formInputChanged = formInputChanged;
var formOpen = _formInteractionEvent.default.onFormOpen;
/**
 * A flavor of the form interaction event (named formInputChanged for legacy reasons)
 * but with action enum FORM_SUBMIT
 *
 * Invoked when a form/dialog is completed.
 */

exports.formOpen = formOpen;
var formSubmit = _formInteractionEvent.default.onFormSubmit;
/**
 * A flavor of the form interaction event (named formInputChanged for legacy reasons)
 * but with action enum FORM_CANCEL
 *
 */

exports.formSubmit = formSubmit;
var formCancel = _formInteractionEvent.default.onFormCancel;
/**
 * A flavor of the form interaction event (named formInputChanged for legacy reasons)
 * but with action enum FORM_MOVE_TO_PAGE
 */

exports.formCancel = formCancel;
var formMoveToPage = _formInteractionEvent.default.onFormMoveToPage;
/**
 * Get current page's page view id from NWA
 */

exports.formMoveToPage = formMoveToPage;

var _default = (0, _objectSpread2.default)({
  logPageView: _logPageView.default,
  formInputChanged: formInputChanged,
  formOpen: formOpen,
  formSubmit: formSubmit,
  formCancel: formCancel,
  formMoveToPage: formMoveToPage,
  getPageViewId: _getPageViewId.default,
  elementInteraction: _elementInteraction.default,
  errorEvent: _errorEvent.default,
  customEvent: _customEvent.default,
  setProductImpressionMeta: _productImpression.default,
  generateUUID: _metaUtils.generateUUID,
  reducer: _reducer.default,
  actions: actions
}, Components);

exports.default = _default;